/**
 * Environment configuration (legacy access).
 *
 * Prefer importing { getConfig } or { getConfigService } from "@/config"
 * so the config source can be replaced. This export delegates to the active config service.
 */

import type { Config } from "./config.types";
import { getConfig } from "./config-service.holder";

/** @deprecated Prefer getConfig() from "@/config" for replaceable config */
export const env: Config = new Proxy({} as Config, {
	get(_, prop) {
		return getConfig()[prop as keyof Config];
	},
});
